import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { MutationOption, queryClient } from "libs/react-query";
import * as KeyFactory from "./exchange-query-key-factory";
import * as VariantKeyFactory from "../../mitigation/variant/variant-query-key-factory";

interface ISetExchangeCategory {
  exchangeId: string;
  category: string;
}

/**
 * Sets the Category of a exchange
 *
 * @param {string} exchangeId - uuid of the exchange
 * @param {string} category - Category of the exchange
 */
export const setExchangeCategory = ({ exchangeId, category }: ISetExchangeCategory) => {
  return Brm.exchangeApi.setExchangeCategory(exchangeId, { body: category });
};

interface IUseSetExchangeCategory {
  options?: MutationOption<typeof setExchangeCategory>;
}

/**
 * Custom hook to change the Category of an existing exchange
 *
 * @param {object} options - react-query configuration object
 * @returns react-query ReactQuery.useMutation
 */
export const useSetExchangeCategory = ({ options }: IUseSetExchangeCategory = {}) => {
  return ReactQuery.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(KeyFactory.exchangeKeys.all);
      queryClient.invalidateQueries(VariantKeyFactory.variantsKeys.all);
    },
    ...options,
    mutationFn: setExchangeCategory,
  });
};
